import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccommodations, selectAccessToken } from '../../store/selectors';
import { getAccommodations } from '../../store/actions';

interface IAccommodationDropdownProperties {
  selectedValue: string[];
  onChange: (event: { value: string[] }) => void;
  allowedCodes?: string[];
}

const AccommodationDropdown: React.FC<IAccommodationDropdownProperties> = ({
  selectedValue,
  onChange,
  allowedCodes,
}) => {
  const dispatch = useDispatch();
  const accommodations = useSelector(selectAccommodations);
  const accessToken = useSelector(selectAccessToken);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if (accommodations.length === 0 && accessToken) {
      dispatch(getAccommodations());
    }
  }, [dispatch, accessToken]);

  useEffect(() => {
    if (accommodations.length > 0) {
      const filteredAccommodations =
        allowedCodes === undefined
          ? accommodations
          : accommodations.filter((accommodation) => allowedCodes.includes(accommodation.code));
      const sortedOptions = filteredAccommodations
        .map((accommodation) => ({
          label: accommodation.code,
          value: accommodation.code,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setOptions(sortedOptions);
    }
  }, [accommodations, allowedCodes]);

  return (
    <MultiSelect
      id="accommodationDropdown"
      value={selectedValue}
      options={options}
      onChange={onChange}
      placeholder="Select Accommodations"
      display="chip"
      filter
    />
  );
};

export default AccommodationDropdown;
